function initStaggerAnimation() {
  const containers = document.querySelectorAll('[data-animate="stagger-slide-up"]');
  if (!containers.length) return;

  function applyStagger(container) {
    const start = Number(container.dataset.delayStart || 0);
    const step  = Number(container.dataset.delayStep  || 100);
    const children = container.querySelectorAll(':scope > *');
    children.forEach((el, i) => {
      const delayMs = start + i * step;
      el.style.animationDelay = (delayMs / 1000) + 's';
    });
  }

  if (!('IntersectionObserver' in window)) {
    containers.forEach(container => {
      applyStagger(container);
      container.classList.add('in-view');
    });
    return;
  }

  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const container = entry.target;
        applyStagger(container);
        container.classList.add('in-view');
        observer.unobserve(container);
      }
    });
  }, 
  {
    root: null,
    threshold: 0.3,
    rootMargin: '0px 0px -50px 0px'
  });

  containers.forEach(c => io.observe(c));
}

document.addEventListener('DOMContentLoaded', initStaggerAnimation);
document.addEventListener('shopify:section:load', initStaggerAnimation);